import React from 'react';
import { ShieldCheck, Activity, ClipboardList } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const TravelDocsPage = () => {
  const config = {
    badge: "Travel Documentation",
    headline: "Pet Travel",
    headlineItalic: "Documentation.",
    subtext: "Complete, hassle-free preparation for domestic and international pet travel, from health certificates to microchipping and rabies titre tests.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Pet Travel Documentation at Dr. Suresh Pet Care — International Travel Preparation",
    stats: [
      { value: 1000, suffix: '+', label: 'Pets Travel-Cleared' },
      { value: 50, suffix: '+', label: 'Destination Countries' },
      { value: 100, suffix: '%', label: 'Documentation Success' },
      { value: 24, suffix: '/7', label: 'Support Available' },
    ],
    services: [
      {
        title: "Health Certificates",
        icon: <ShieldCheck size={28} />,
        desc: "Officially endorsed veterinary health certificates required for domestic and international airline travel.",
        specs: ["Government Endorsed", "Airline Approved", "Breed-Specific Docs", "Physical Examination"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "Microchipping",
        icon: <Activity size={28} />,
        desc: "ISO-standard microchip implantation for permanent identification — required by most countries for entry.",
        specs: ["ISO 15-digit Chip", "Painless Implant", "International DB", "Registration Support"],
        color: "from-primary/10 to-green-500/10"
      },
      {
        title: "Titre Testing & Vaccines",
        icon: <ClipboardList size={28} />,
        desc: "Rabies antibody titre testing, boosters, and import-specific vaccination documentation for global entry.",
        specs: ["Rabies Titre Test", "Vaccine Records", "Specific Country Protocols", "Export Certificate"],
        color: "from-amber-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Travel",
    sectionItalic: "Services.",
    warningTitle: "Travel",
    warningItalic: "Requirements.",
    warningText: "Pet travel regulations vary hugely by country and airline. Preparation 6-8 weeks in advance ensures a smooth, stress-free journey for your pet.",
    warnings: [
      { name: "Health Cert Timing", desc: "Most airlines require health certificates issued within 10 days of travel.", icon: "📋" },
      { name: "Microchip First", desc: "Microchipping must always precede rabies vaccination for titre test validity.", icon: "🔢" },
      { name: "Breed Restrictions", desc: "Many airlines restrict brachycephalic breeds — check early for alternatives.", icon: "✈️" },
      { name: "Destination Rules", desc: "Some countries require 180+ day waiting periods after titre tests — plan ahead.", icon: "⏱️" },
    ],
    ctaBadge: "Travel Experts",
    ctaTitle: "The Travel Doc",
    ctaItalic: "Expertise.",
    ctaText: "Our travel documentation team has helped over 1,000 pets travel safely across the globe. We guide you through every requirement from start to finish.",
    ctaBtn: "Start Travel Preparation",
    seoText: "Pet travel documentation in Hyderabad. Health certificates, microchipping and rabies titre testing for international pet travel at Dr. Suresh Pet Care.",
    glowColor: "blue-500"
  };

  return (
    <>
      <SEO 
        title="Pet Travel Documentation"
        description="Complete pet travel documentation services including health certificates, microchipping, and international travel preparation at Dr. Suresh Pet Care, Hyderabad."
        canonical="/travel-docs"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default TravelDocsPage;
